import _ from 'lodash';

const handleNavigate = async (
  currentListData,
  currentReportId,
  handleShowDetail,
  handleCloseDetail,
  handleGetAllDataTable,
  isNext
) => {
  const currentIndex = _.findIndex(
    currentListData,
    report => report.id === currentReportId
  );

  const handleNextNavigation = async () => {
    if (currentIndex === _.size(currentListData) - 1) {
      const newData = await handleGetAllDataTable();
      if (_.isEmpty(newData)) {
        handleCloseDetail();
      } else {
        let newIndex = _.findIndex(newData, { id: currentReportId });
        newIndex = newIndex === -1 ? currentIndex : newIndex + 1;
        if (newIndex > newData.length - 1) {
          newIndex = 0;
        }
        const nextReportId = newData[newIndex].id;
        await handleShowDetail(nextReportId);
      }
    } else {
      await handleShowDetail(currentListData[currentIndex + 1].id);
    }
  };

  const handlePreviousNavigation = async () => {
    if (currentIndex === 0) {
      const newData = await handleGetAllDataTable();
      if (_.isEmpty(newData)) {
        handleCloseDetail();
      } else {
        let newIndex = _.findIndex(newData, { id: currentReportId });
        newIndex = newIndex === -1 ? currentIndex - 1 : newIndex - 1;
        if (newIndex < 0) {
          newIndex = newData.length - 1;
        }
        const nextReportId = newData[newIndex].id;
        await handleShowDetail(nextReportId);
      }
    } else {
      await handleShowDetail(currentListData[currentIndex - 1].id);
    }
  };

  if (isNext) {
    await handleNextNavigation();
  } else {
    await handlePreviousNavigation();
  }
};

const KyReportUtility = {
  handleNavigate,
};

export default KyReportUtility;



// WEBPACK FOOTER //
// ./src/utilities/kyReportUtil.js